import * as axios from 'axios'
import { getAuthHeaders } from './request'
import Storage from '../lib/storage'
import omit from 'lodash-es/omit'

export const userRequest = async (method, path, params, authHeaders = false, data = {}, withCredentials = true) => {
  let headers = {}
  if (authHeaders) {
    headers = getAuthHeaders()
  }
  if (params.headers != null) {
    headers = {
      ...headers,
      ...params.headers
    }
  }
  return axios({
    method,
    headers,
    withCredentials,
    params: omit(params, ['headers']),
    data,
    /*
      #TODO: Find a different way to get this variable from
      outside the React model.
      -- TJC - May 07, 2021
    */
    url: `${window.__env.REACT_APP_USER_API_URL}${path}`,
    timeout: 30000, // 30 second timeout
    maxRedirects: 5,
    validateStatus: function (status) {
      return status >= 200 && status < 300 // default
    }
  })
    .then(response => {
      if (response) {
        /*
        #TODO: Move these into the userProfile functions
        -- TJC - April 13, 2021
      */
        if (path == '/extend' || path == '/whoami') {
          Storage.removeEncoded('currentUser')
          Storage.storeEncoded('currentUser', response.data.result)
        }

        if (path == '/logout') {
          Storage.removeEncoded('currentUser')
        }

        if (path == '/config') {
          return { success: true, data: response.data }
        }
      }
      return { success: true, data: response.data.result }
    })
    .catch(error => {
      return { success: false, data: error }
    })
}
